import { Middlewares } from "@/app/shared/services/app-router/middlewares";
import Guard from "vue-router-multiguard";

export default [
    {
        path: "/outgoing-phones",
        name: "OutgoingPhonesList",
        component: () => import("./views/outgoingPhonesList.vue"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
];
